module.exports = __webpack_public_path__ + "img/add-member-big.25a17b02.svg";